import React, { useState } from "react";
import { Box, TextField, Chip, IconButton, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { colors } from "../../theme/theme";

const TagInput = ({ hashTags, setHashTags }) => {
  const [inputValue, setInputValue] = useState("");

  const handleAddTag = () => {
    if (inputValue.trim() && !hashTags.includes(inputValue.trim())) {
      setHashTags([...hashTags, inputValue.trim()]);
      setInputValue("");
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    setHashTags(hashTags.filter((tag) => tag !== tagToDelete));
  };

  return (
    <Box
      sx={{
        border: "1px solid #000",
        borderRadius: "0px",
        px: 1,
        py: 1,
        mb: 2,
      }}
    >
      {/* Tags wrap above input */}
      {hashTags.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            mb: 1,
          }}
        >
          {hashTags.map((tag, index) => (
            <Chip
              key={index}
              label={tag}
              onDelete={() => handleDeleteTag(tag)}
              sx={{
                backgroundColor: colors.primary,
                color: "#fff",
                fontWeight: "500",
                "& .MuiChip-deleteIcon": {
                  color: "#fff",
                },
              }}
            />
          ))}
        </Box>
      )}

      {/* Input + Add icon with fixed height */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "35px",
        }}
      >
        <TextField
          fullWidth
          placeholder="e.g. #MuayThai"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddTag()}
          InputProps={{
            sx: {
              height: "100%",
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                border: 0,
                height: "100%",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            },
          }}
        />
        <IconButton onClick={handleAddTag}>
          <AddIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TagInput;
